import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SkillCard from "../SkillCard";
import * as constants from "../../../../../constants";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import {
  purple,
  grey,
  text,
  white,
  legendBackground,
} from "../../../../../theme/colours";

const TrypsLegend = ({ setOpen }) => {
  const { t } = useTranslation("Tryps");
  const { mobileView, tabletView, desktopView } = useContext(GlobalContext);

  const containerStyle = {
    height: "fit-content",
    p: mobileView ? "5%" : "3%",
    background: "white",
    borderRadius: "1rem",
  };
  const titleBox = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const closeStyle = {
    color: white,
    background: text.primary,
    borderRadius: "50%",
    fontSize: "1rem",
  };
  const contentsBox = {
    display: "flex",
    flexDirection: desktopView ? "row" : "column",
    justifyContent: "space-between",
  };
  const boxStyle = {
    mt: mobileView ? "4%" : "2%",
    p: mobileView ? "6%" : tabletView ? "4%" : "3%",
    background: legendBackground,
    borderRadius: "0.75rem",
    boxShadow: `${grey[1]} inset 0px 2px 10px -4px`,
  };
  const skillsBox = {
    width: desktopView ? "55%" : "100%",
  };
  const cardBox = {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
  };
  const spacer = {
    width: mobileView ? "48%" : tabletView ? "31%" : "23%",
    height: "3rem",
    mt: "3%",
  };
  const colorBox = {
    width: desktopView ? "42%" : "100%",
    pr: desktopView ? "10%" : tabletView ? "4%" : "6%",
  };
  const systemTitleStyle = {
    width: "100%",
  };
  const colorLegendContainerStyle = {
    display: "flex",
    flexDirection: desktopView ? "row" : "column",
    pt: desktopView && "1rem",
  };
  const borderBoxStyle = {
    m: "0 2rem",
    border: `solid 1px ${grey[1]}`,
  };
  const colorSectionStyle = {
    mt: (mobileView || tabletView) && "1rem",
  };
  const legendBox = {
    display: "flex",
    flexFlow: desktopView ? "column wrap" : "row wrap",
    justifyContent: "space-between",
    width: desktopView ? "fit-content" : "100%",
    height: desktopView ? "7rem" : "fit-content",
    mt: desktopView ? "1rem" : "0.5rem",
  };
  const elementBox = {
    display: "flex",
    alignItems: "center",
    width: desktopView ? "100%" : "33%",
    m: "0.5rem 0",
  };
  const colorCircle = {
    width: "0.9rem",
    height: "0.9rem",
    mr: desktopView ? "1rem" : "0.5rem",
    borderRadius: "50%",
    boxShadow: "0px 2px 3px 1px lightgrey",
  };

  const ColorLegend = ({ type }) => {
    const colors = `${type}_COLORS`;
    return (
      <Box sx={colorSectionStyle}>
        <Typography variant="h3">
          {type === "EVENT" ? t("byEvents") : t("byScore")}
        </Typography>
        <Box sx={legendBox}>
          {Object.keys(constants[colors]).map((key) => (
            <Box sx={elementBox} key={key}>
              <Box
                sx={{ ...colorCircle, background: constants[colors][key] }}
              />
              <Typography variant="body1">{key}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={titleBox}>
        <Typography variant="h1" textTransform="uppercase">
          {t("legend")}
        </Typography>
        {(mobileView || tabletView) && (
          <CloseIcon
            sx={closeStyle}
            onClick={() => {
              setOpen(false);
            }}
          />
        )}
      </Box>
      <Box sx={contentsBox}>
        <Box sx={{ ...boxStyle, ...skillsBox }}>
          <Typography variant="h2" color={purple[1]}>
            {t("skillsEvents")}
          </Typography>
          <Box sx={cardBox}>
            {constants.SKILLS_LIST.map((skill) => (
              <SkillCard
                skill={skill}
                key={skill}
                icon={constants.TRYP_SVGS[skill]}
              />
            ))}
            <Box sx={spacer} />
          </Box>
        </Box>
        <Box sx={{ ...boxStyle, ...colorBox }}>
          <Typography sx={systemTitleStyle} variant="h2" color={purple[1]}>
            {t("colorScoringSystem")}
          </Typography>
          <Box sx={colorLegendContainerStyle}>
            <ColorLegend type="EVENT" />
            {desktopView && <Box sx={borderBoxStyle} />}
            <ColorLegend type="SCORE" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TrypsLegend;
